import { render, staticRenderFns } from "./openIndex.vue?vue&type=template&id=76aa9e6b&"
import script from "./openIndex.vue?vue&type=script&lang=js&"
export * from "./openIndex.vue?vue&type=script&lang=js&"
import style0 from "./openIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports